import React from 'react';
import { Link } from 'react-router-dom';
import { FaHotel } from "react-icons/fa6";
import { IoRestaurantOutline } from "react-icons/io5";
import { RiComputerFill } from "react-icons/ri";
import { FcNeutralTrading } from "react-icons/fc";
import { BsBuildingsFill } from "react-icons/bs";

function Service() {
  return (
    <>
      <section id="services" className="services section light-background">
        {/* Section Title */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Our Services</h2>
         <p>
    Delivering innovative solutions across IT, construction, and design — helping businesses and individuals achieve excellence with efficiency and creativity.
  </p>
        </div>
        {/* End Section Title */}
        <div className="container">
          <div className="row gy-4">

            <div className="col-lg-4 col-md-6 service-item d-flex" data-aos="fade-up" data-aos-delay={100}>
              <div className="icon flex-shrink-0">
                <FaHotel size={28} color="#4169E1"/>
              </div>

              <div>
                <h4 className="title">
                 
                  <Link to="/hotel-service" className="stretched-link">
                    Hotel & Hospitality
                  </Link>
                </h4>
                <p>We deliver comfort, class, and care through our premium hospitality services. With a focus on guest satisfaction and operational excellence, our hotels blend modern amenities with traditional values, offering a memorable experience for business and leisure travelers alike</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 service-item d-flex" data-aos="fade-up" data-aos-delay={200}>
              <div className="icon flex-shrink-0">
                <IoRestaurantOutline  size={28} color="#4169E1"/></div>
              <div>
                <h4 className="title">
                  <Link to="/catering-service" className="stretched-link">
                    Catering Services
                  </Link>
                </h4>
                <p>Our Makkah branch operates as a dedicated food service restaurant delivering high-quality meals with a focus on taste, hygiene, and customer satisfaction. Located in haram,Makkah-Saudi Arabia, this branch serves a wide range of customers, including local residents, pilgrims, and visitors from across the world.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 service-item d-flex" data-aos="fade-up" data-aos-delay={300}>
  <div className="icon flex-shrink-0">
    <RiComputerFill size={28} color="#4169E1" />
  </div>
  <div>
    <h4 className="title">
      IT Solutions
      <a 
        href="https://www.mac-itsolution.com" 
        className="stretched-link" 
        target="_blank" 
        rel="noopener noreferrer"
      >
       
      </a>
    </h4>
    <p>
      Empowering businesses with cutting-edge technology — our IT division offers tailored software, hardware, and digital transformation solutions. From network infrastructure to enterprise systems, we help clients stay secure, smart, and future-ready.
    </p>
  </div>
</div>


            <div className="col-lg-4 col-md-6 service-item d-flex" data-aos="fade-up" data-aos-delay={400}>
              <div className="icon flex-shrink-0">
                <FcNeutralTrading size={28} color="#fff"/></div>
              <div>
                <h4 className="title">
                  <Link to="/trading-service" className="stretched-link">
                              Logistics And Supply Chain Management 
                  </Link>
                </h4>
                <p> We provide efficient logistics and supply chain management solutions to ensure smooth transportation, timely delivery, and streamlined operations. With a strong distribution network and strategic planning, we help businesses move goods safely and reliably across regions.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 service-item d-flex" data-aos="fade-up" data-aos-delay={500}>
              <div className="icon flex-shrink-0">
                <BsBuildingsFill size={28} color="#4169E1"/></div>
              <div>
                <h4 className="title">
                  <Link to="/building-service" className="stretched-link">
                   Building Materials
                  </Link>
                </h4>
                <p>Backed by 21+ years of industry experience, our building materials division supplies premium construction products — including cement, steel, lighting, plumbing, safety, sanitary ware, and more. Trusted by contractors, developers, and architects alike.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 service-item d-flex" data-aos="fade-up" data-aos-delay={600}>
              <div className="icon flex-shrink-0"><i className="bi bi-calendar4-week" /></div>
              <div>
                <h4 className="title">
                  <Link to="/food-store" className="stretched-link">
                    MFS-Makkah Food Store
                  </Link>
                </h4>
                <p>We install reliable, high-speed structured cabling systems to support all your data and communication needs.</p>
              </div>
            </div>

             <div className="col-lg-4 col-md-6 service-item d-flex" data-aos="fade-up" data-aos-delay={600}>
              <div className="icon flex-shrink-0"><i className="bi bi-calendar4-week" /></div>
              <div>
                <h4 className="title">
                  <Link to="/plastic-and-cosmestics" className="stretched-link">
                  MPC-Makkah Plastic and Cosmestics.
                  </Link>
                </h4>
                <p>We install reliable, high-speed structured cabling systems to support all your data and communication needs.</p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default Service;
